import { CssType, ThemeType } from '@theming/jssTypes';

export const styles = (theme: ThemeType) => ({
  wrapper: {
    display: 'flex',
    width: '100%',
    height: '100%',
  },
  chatComponent: {
    display: 'flex',
    flexDirection: 'column',
    width: '60%',
    padding: theme.spacing[4],
    height: '100%',
  },
  chats: {
    overflowY: 'scroll',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    backgroundColor: theme.color.semantic.background.neutral.secondary,
  },
  files: {
    overflowY: 'scroll',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  addChat: {
    border: `${theme.border.width.sm} solid ${theme.color.semantic.border.secondary}`,
    width: '100%',
  },
  textArea: {
    padding: theme.spacing[3],
    width: '100%',
    border: theme.border.width[0],
    height: '60%',
    resize: 'none',
    outline: 'none',
    '& ant-input:focus': {
      border: `${theme.border.width[0]} none ${theme.color.semantic.background.neutral.secondary}`,
      overflow: 'hidden',
      outline: 'none !important',
      boxShadow: `${theme.shadow.none} !important`,
    },
  },
  chatMetaData: {
    display: 'flex',
    alignItems: 'center',
  },
  chatAuthor: {
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.semibold,
  },
  separator: {
    fontSize: theme.typography.fontSize.xxs,
    color: theme.color.semantic.text.tertiary,
    marginLeft: theme.spacing[1],
    marginRight: theme.spacing[1],
  },
  chatTime: {
    fontSize: theme.typography.fontSize.sm,
    color: theme.color.semantic.text.tertiary,
    fontWeight: theme.typography.fontWeight.regular,
  },
  chatWrapper: {
    fontFamily: theme.typography.fontFamily.primary,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing[3],
  },
  text: {
    fontSize: theme.typography.fontSize.sm,
    marginTop: theme.spacing[1],
    lineHeight: theme.spacing[4],
  },
  spinner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  chatAttachments: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  fileComponent: {
    width: '40%',
    // overflowY: 'scroll',
    backgroundColor: theme.color.semantic.background.neutral.subtle,
    padding: theme.spacing[4],
    marginBottom: theme.spacing[4],
    display: 'flex',
    flexDirection: 'column',
  },
  fileComponentHeader: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: theme.spacing[3],
  },
  tag: {
    fontSize: theme.typography.fontSize.xxs,
    backgroundColor: theme.color.semantic.border.secondary,
    height: '18px',
    width: '68px',
    borderRadius: theme.radius.xs,
    lineHeight: theme.typography.fontSize.xs,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: theme.typography.fontWeight.semibold,
  },
  emptyFileWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
    backgroundColor: theme.color.semantic.background.neutral.secondary,
  },
  fileDescription: {
    color: theme.color.semantic.text.tertiary,
    fontWeight: theme.typography.fontWeight.regular,
    fontSize: theme.typography.fontSize.md,
    lineHeight: theme.spacing[4],
  },
  emptyChatWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
  },
  chatDescription: {
    color: theme.color.semantic.text.tertiary,
    fontWeight: theme.typography.fontWeight.regular,
    fontSize: theme.typography.fontSize.md,
    lineHeight: theme.spacing[4],
  },
  privateModeWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing[3],
    maxHeight: '100%',
  },
  commentButton: {
    height: '22px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginLeft: theme.spacing[4],
    fontSize: theme.typography.fontSize.sm,
    paddingTop: theme.spacing[0],
  },
  fileCountWrapper: {
    fontSize: theme.typography.fontSize.md,
    fontWeight: theme.typography.fontWeight.bold,
    lineHeight: theme.typography.fontSize.md,
    color: theme.color.semantic.text.primary,
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
  },
  divider: {
    borderBottom: `${theme.border.width.sm} solid ${theme.color.semantic.border.secondary}`,
    marginBottom: theme.spacing[3],
  },
});
